const t = {
  name: "OauthAutomation",
  dimensions: { width: 39, height: 39 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.4 39.4" style="enable-background:new 0 0 39.4 39.4;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12.3,3.7L10,1.4L11.4,0l4.7,4.7l-4.7,4.7L10,8l2.3-2.3H5.7v9h-2v-11H12.3z"/>
		<path class="st0" d="M28.7,3.7h-4v2h4c2.8,0,5,2.2,5,5v1.6L31.4,10L30,11.4l4.7,4.7l4.7-4.7L38,10l-2.3,2.3v-1.6
			C35.7,6.8,32.6,3.7,28.7,3.7z"/>
		<path class="st0" d="M10.7,10.7h13c2.8,0,5,2.2,5,5v13h-13c-2.8,0-5-2.2-5-5V10.7z M12.7,12.7v11c0,1.7,1.3,3,3,3h11v-11
			c0-1.7-1.3-3-3-3H12.7z"/>
		<path class="st0" d="M4.7,23.3L9.4,28L8,29.4l-2.3-2.3v1.6c0,2.8,2.2,5,5,5h4v2h-4c-3.9,0-7-3.1-7-7v-1.6l-2.3,2.3L0,28L4.7,23.3z
			"/>
		<path class="st0" d="M27.1,33.7l2.3-2.3L28,30l-4.7,4.7l4.7,4.7l1.4-1.4l-2.3-2.3h8.6v-11h-2v9H27.1z"/>
	</g>
</g>
</svg>
  `
};
export {
  t as OauthAutomation
};
